import { type UseQueryResult, useQuery } from 'react-query';
import { ParticipantAccountTypeService } from '../../services/wealthlane-customer-services';

const useGetParticipantAccountType = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
    }>
  | undefined,
  unknown
> => {
  const ParticipantAccountTypeList = useQuery(
    ['getParticipantAccountTypeList'],
    async () => {
      return await handleRequest(
        ParticipantAccountTypeService.getApiCustomerApiAppParticipantAccountTypeParticipantAccountTypesList()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return ParticipantAccountTypeList;
};

export default useGetParticipantAccountType;
